
import { Component, Vue } from "vue-property-decorator";
import { uiStore, configStore, documentStore } from "@/store/store";
import OnCanvasDragHandle from "./OnCanvasDragHandle.vue";
import { findNode } from "@/lib/tree/tree";
import {
  getNodeElementWrapperStyles,
  getDomElementFromTreeNode,
  getNodeTitlebarStyles
} from "@/lib/canvas/helpers";
import { forceNextTick } from "@/util/force-next-tick";
import Icon from "@/components/UI/Icon.vue";
import { IconName } from "@/lib/icons/icons";
import { getElementIcon, getElementName } from "@/lib/elements/utils";
import { SECTION_SLUG } from "@/lib/elements/constants";
import lodash from "lodash";
import ElementIcon from "@/components/UI/ElementIcon.vue";

@Component({
  components: {
    Icon,
    OnCanvasDragHandle,
    ElementIcon
  }
})
export default class NodeTitlebarOutline extends Vue {
  interval!: NodeJS.Timer;
  refreshRate = 500;

  unsubscribeFromStorePositionWrapper = () => {};
  nextTickPositionsWrapper() {
    forceNextTick(this.calculateStylesAndTitle);
  }

  get builderMode() {
    return configStore.builderMode;
  }

  get isDragging() {
    return !!uiStore.currentlyDraggingCanvasElementId;
  }

  mounted() {
    this.calculateStylesAndTitle();

    this.unsubscribeFromStorePositionWrapper = this.$store.subscribe(
      this.nextTickPositionsWrapper
    );

    window.addEventListener("resize", this.nextTickPositionsWrapper);

    this.interval = setInterval(
      this.nextTickPositionsWrapper,
      this.refreshRate
    );
  }

  beforeDestroy() {
    this.unsubscribeFromStorePositionWrapper();

    window.removeEventListener("resize", this.nextTickPositionsWrapper);

    clearInterval(this.interval);
  }

  get isDraftSection() {
    if (!this.element) return false;

    if (this.element.data.type !== SECTION_SLUG) return false;

    const isDraft = lodash.get(
      this.element.data.properties,
      "settings.advanced.draft"
    );

    return !!isDraft;
  }

  titlebarPositionStyle: { [key: string]: string } = {};

  wrapperPositionStyle: { [key: string]: string } = {
    display: "none"
  };

  elementTitle = "";

  // Everything is calculated in a func to avoid UI flicker caused by values being calculated at different times
  calculateStylesAndTitle() {
    if (
      !this.element ||
      (this.activeElement && this.activeElement.id === this.elementId)
    ) {
      this.wrapperPositionStyle = {
        display: "none"
      };

      return;
    }

    this.elementTitle = this.getElementTitle();

    this.wrapperPositionStyle = getNodeElementWrapperStyles(
      getDomElementFromTreeNode(this.element)
    );

    this.titlebarPositionStyle = getNodeTitlebarStyles(this.element);
  }

  get titlebarClasses() {
    return {
      "node-titlebar-is-offset": !!this.wrapperPositionStyle.outlineOffset
    };
  }

  get activeElement() {
    return uiStore.activeElement;
  }

  get element() {
    if (!uiStore.lastHoveredOnCanvasElementId) return false;

    const lastHoveredElement = findNode(
      documentStore.document.tree,
      uiStore.lastHoveredOnCanvasElementId
    );

    return lastHoveredElement || false;
  }

  get elementId() {
    return this.element ? this.element.id : null;
  }

  getElementTitle() {
    if (!this.element) return "";
    return getElementName(this.element);
  }

  get elementIcon(): IconName {
    if (!this.element) return "MaximizeIcon";
    return getElementIcon(this.element, true);
  }

  get node() {
    // False should never happen
    return this.element || false;
  }
}
